import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tw3-mb-5 tw3-flex tw3-items-start tw3-gap-3" }
const _hoisted_2 = { class: "tw3-text-lg tw3-font-semibold" }
const _hoisted_3 = {
  key: 0,
  class: "tw3-mt-0.5 tw3-text-sm tw3-text-surface-500"
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingCardHeader',
  props: {
    title: {},
    subtitle: { default: '' },
    icon: { default: '' },
    tone: { default: 'emerald' }
  },
  setup(__props: any) {

const props = __props;

const toneClass = computed(() =>
	props.tone === 'sky'
		? 'tw3-bg-sky-100 tw3-text-sky-700'
		: 'tw3-bg-primary-50 tw3-text-primary-600'
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["tw3-flex tw3-size-10 tw3-shrink-0 tw3-items-center tw3-justify-center tw3-rounded-xl", toneClass.value])
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.icon)
          }, null, 2)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})